<template>
    <split-pane  :min-percent='10' :default-percent='12' split="vertical" style="background:white; height:100%">
        <template slot="paneL"  >
            <div style="line-height:30px;height:30px;background:#808694;" >
                <el-button @click="addRec" :disabled="addBool" type="text" icon="iconfont icon-xinzeng" style=" line-height:5px;margin-right:3px;color:white">新增</el-button>
                <el-button @click="editRec" :disabled="editBool" type="text" icon="iconfont icon-bianji" style=" line-height:5px;margin-right:3px;color:white">编辑</el-button>
                <el-button @click="delRec" :disabled="delBool" type="text" icon="iconfont icon-shanchu1" style=" line-height:5px;color:white">删除</el-button>
            </div> 
            <el-tree :data="treeData" 
                        :props="defaultProps" 
                        @node-click="handleNodeClick" 
                        node-key="id"    
                        :default-expand-all="true"    
                        :style="{background:'#fFF',overflow:'auto',height: scrollerHeight}"
                        highlight-current
                        :filter-node-method="filterNode"
                        ref="eltree"
                        :expand-on-click-node="false">
                <template v-slot="{node,data}">                                     
                    <span v-if="data.parentid =='#' "  >
                        <span  style=" font-size:14px;color:#389;font-size:14px;font-weight:600"><i class="iconfont icon-fenlei" style="color:#389;font-size:18px;font-weight:700"></i> {{ node.label}} </span>
                    </span>                  
                    <span v-else  > 
                        <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-wenjianmulu" style="margin-right:5px;"></i>{{ node.label}} </span>
                    </span>
                </template>
            </el-tree>
        </template>
        <template slot="paneR"> 
            <div style="height:88vh;overflow-y:auto">
                <div style=" background:#fff; display:flex;line-height:30px;border-bottom:2px solid #389;padding-top:3px" >
                                     
                    <el-input clearable ref="refinput" :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="qryTabData" size="small" style="width:340px; height:30px;margin-left:2px ">
                        <!-- <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                            </span>
                        </el-select> -->
                        <el-select v-model="selparam" slot="prepend" placeholder="请选择列名" clearable size="small" style="width:120px;height:30px; ">
                            <span v-for="(item,index) in tabCol" :key='index' >
                                <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'&&item.key!=='NOTE'"></el-option>
                            </span>
                        </el-select>
                        <el-button size="small" slot="append" icon="el-icon-search" @click="qryTabData" ></el-button>
                    </el-input>
                </div>
                <el-table  :data="tabData" 
                    border                            
                    disabled-hover
                    class="custom-table-border"
                    :row-key="getRowKeys"
                    @row-click="rowClick"
                    style="overflow:auto;margin-top:1px;"
                    ref="tabref"
                    :height="200" 
                    highlight-current-row>
                    <el-table-column  v-for="(item,index ) in tabCol.filter(item=>item.thide=='N')" :key="index"
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            :sortable="item.key!=='RN'"
                            :min-width="item.width">
                        <template slot-scope="scope">
                            <span v-text ="scope.row[item.key]"></span>
                        </template>
                    </el-table-column> 
                    <el-table-column
                        fixed="right"
                        label="操作"
                        align="center"
                        width="80">
                        <template slot-scope="scope">
 
                            <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:14px;margin-right:5px;"></i>
                            <el-link :disabled="delBool"  @click="delInfo(scope.row,scope.$index)" :underline="false"  ><span style="font-size:11px;">删除 </span></el-link>     
                        </template>
                    </el-table-column>                         
                </el-table>
                <div style=" margin-top:2px;margin-bottom:2px; font-size:12px;line-height:30px;background:#fff;height:35px;border-bottom:2px solid #389;">    
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:3px;margin-left:3px;"></i>
                    <el-link :disabled="addBool"  @click="addInfo" :underline="false"  ><span style="font-size:13px;">新增信息发布</span></el-link>  
                    <i class="iconfont icon-baocun" style="color:#409EFF;font-size:14px;margin-right:3px;margin-left:20px;"></i>
                    <el-link :disabled="addBool"  @click="saveInfo" :underline="false"  ><span style="font-size:13px;">保存 </span></el-link> 
                    <i class="iconfont icon-chexiao" style="color:#409EFF;font-size:14px;margin-right:3px;margin-left:20px;"></i>
                    <el-link :disabled="addBool"  @click="qryTabData" :underline="false"  ><span style="font-size:13px;">取消保存 </span></el-link> 
 
                </div>
            
                <div style="display:flex;justify-content:space-between;width:100%;margin-bottom:-10px; ">
                    <Form :model="newRow" :label-width="120"  label-position="right" inline  >  
                        <span v-for="(item,index) in tabCol" :key="index" >
                            <FormItem  :class=" 'row-width'" :prop="item.key"  v-if="item.fhide==='N'">     
                                <template slot="label"><span v-if="item.notnull=='Y'" style="color:red;margin-right:4px">*</span>{{item.title}}</template>              
                                <el-date-picker size="medium" type="date"  v-if="item.edcss==='date'" v-model="newRow[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>    
                                <el-input size="small"   @focus="inputBtn(  item.key)" v-else-if="item.edcss=='button'"   v-model="newRow[item.key]" style="width:100%;border:1px solid #f7f8f9"> </el-input>  
                                <el-input  size="medium" type="text" v-else :disabled="item.disabled==='Y'?true:false "  v-model="newRow[item.key]"></el-input>
                            </FormItem>
                        </span> 
                    </Form> 
                </div>
                <div style="margin-top:3px;width:100%;padding-right:10px;" v-if="isTinymce">
                    <tinymce id="refnew" v-model="newHtml" height="260"  ></tinymce>
                </div>
                <div style="line-height:30px;border-bottom:2px solid #389;margin-top:5px;background:white"><i class="iconfont icon-xinxi" style="margin-right:4px;color:red"></i>最多上传3个附件(可以是图片格式或PDF格式）</div>
                <div style="display:flex;margin-top:15px;" >
                    <Upload
                        ref="upload"
                        name="upfile"
                        :data="uploadData"
                        :show-upload-list="false"
                        :before-upload="beforeImgFile"
                        :on-success="successImgFile"
                        :on-progress="handleProgress"
                        :with-credentials="true"                            
                        :format="['jpg','jpeg','png','gif','bmp','tiff','pdf' ]"
                        :max-size="20480"
                        :on-format-error="handleFormatError"
                        :on-exceeded-size="handleMaxSize"
                        type="drag"
                        :action="uploadUrl"
                        style="display: inline-block;width:200px; ">                           
                        <div style="padding: 1px 0;width:200px;height:150px;">
                            <el-image src="/assets/basedict/nopic.png" style="margin-top:30px;"></el-image> 
                            <p style="color:#515a6e;margin-top:5px;">将文件拖动此处或点击上传</p>
                        </div>                                                       
                    </Upload> 
                    <div style="display:flex; "  >
                        <span v-for="(item,index) in imgData" :key="index">  
                            <div v-if="item.FILEPATH &&item.FILEPATH.lastIndexOf('.pdf')>-1" style="width:150px;height:125px;border:1px solid #e8eaec;overflow-y:hidden">
                                <iframe :src="item.FILEPATH" frameborder="0" style="width: 100%; height: 100%"></iframe>
                            </div>
                            <el-image v-else :preview-src-list="[item.FILEPATH]" fit="fill"  style="width:150px;height:125px;margin-right:30px;" :src="item.FILEPATH">
                                <div   slot="error" ><span style="font-weight:600;font-size:12px;color:red"> 文件名称：</span>{{item.FILENM}} </div>
                            </el-image>
                            <div style="height:25px;background:#e8eaec;width:150px; display:flex;justify-content:space-between">
                                <el-link :disabled="saveFlag" :underline="false" @click="imgDel(item.IDSEQ,item.LSTSEQ,item.FILEPATH,index)"><Icon type="md-close" /> 删除</el-link>
                                <el-link v-if="item.FILEPATH.lastIndexOf('.pdf')>-1" :underline="false" @click="pdfViewer(item.FILEPATH)"><Icon type="ios-search" /> 预览</el-link>
                                <el-link v-else :underline="false" style="margin-right:5px;" @click="downFile(item.FILEPATH)"><i class="iconfont icon-xiazai" style="margin-right:3px"></i>下载</el-link>
                            </div>
                        </span>
                    </div>  
                </div>
            </div>
            <el-dialog v-dialogDrag  :visible.sync="addWin"  width="400px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body >
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
                </div>  
                <Form ref="addForm" :model="formCol" :label-width="110"   label-position="right" inline >
                    <FormItem label="上级类型编码" class="item-width" >                                  
                        <el-input type="text" disabled  v-model="formCol.PARENTNO" style="width:100%"  />
                    </FormItem>
                    <FormItem label="上级类型名称"  class="item-width" >                                  
                        <el-input type="text" disabled   v-model="formCol.PARENTNM" style="width:100%" />
                    </FormItem>
                    <FormItem label="本级类型编码" class="item-width"  >                                  
                        <el-input type="text" disabled   v-model="formCol.CODE" style="width:100%" />
                    </FormItem>
                    <FormItem  class="item-width" >     
                        <template slot="label"><span style="color:red">*</span>本级类型名称</template>                             
                        <el-input type="text"  v-model="formCol.CNAME" style="width:100%"  clearable/>
                    </FormItem>
 
                </Form>                      
                <div slot="footer">
                    <span style="float:right;line-height:35px"> 
                        <el-button type="info" size="small" style="margin-right:40px;" icon="iconfont icon-shanchu" @click="addWin=false">取消</el-button>
                        <el-button type="primary" size="small"   icon="iconfont icon-baocun" @click="saveTree"  >确定</el-button>
                    </span>
                </div>
            </el-dialog>  
            <!-- 提示框 -->
            <el-dialog  :visible.sync="promptWin" v-dialogDrag width="450px" :close-on-click-modal="false" :close-on-press-escape="false" append-to-body>
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">提示</span>
                </div>
                <span>{{prompt}}</span>
                <span slot="footer"  >
                    <el-button type="primary" size="small" @click="promptWin = false">确 定</el-button>
                </span>
            </el-dialog>
 
            <!-- 上传进度 -->
            <el-dialog :visible.sync="videoFlag" width="150px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'30px'}">
                    <span style="line-height:30px;height:30px;font-size:16px;padding-left:5px;">正在上传中...</span>
                </div>
                <el-progress   type="circle" :percentage="videoUploadPercent"  ></el-progress>  
            </el-dialog>
            <el-dialog v-dialogDrag :visible.sync="showViewer" width="1200px" append-to-body top="3vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">预览</span>
                </div>
                <el-image fit="scale-down"  :style="{'margin':'5px auto',height:imgHeight, 'width':'100% '}" :src="listurl"></el-image>
            </el-dialog>
            <!-- 引用选择框 -->
            <el-dialog  v-dialogDrag   :visible.sync="btnWin" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
                <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                    <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
                </div> 
                <pub-win  v-bind:tabCol ="tableCol" v-bind:v_random="v_random" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
            </el-dialog>
        </template>
    </split-pane>
</template>
<script>
import { getTabColOrData,getBaseData } from '../../api/user'
import tinymce from '@/components/Tinymce' 
import { getDate } from '@/api/Select'
import pubWin from '../datamgt/pubwin.vue' 
import FileSaver from 'file-saver'
    export default {
        name: "info_release",
        data(){
            return {
                isTinymce:true,
                v_table:'',
                tableCol :[],
                v_key2 :'',
                v_value2 :'',
                v_random:'',
                btnWin:false,
                v_key:'',
                videoUploadPercent:0,
                videoFlag:false,
                newRow:{},
                newHtml:'',
                operArr:[],
                treeData:[] ,//  树数据
                filterText: '',
                nodeData:{},
                input_hold:'请输入内容...',
                defaultProps: {  //el-tree 默认字段属性
                    children: 'children',
                    id:'id',
                    icon:'icon',
                    label: 'label',
                    parentid:'parentid'
                },
                promptWin:false,
                addFlag: 'create',
                prompt:'',
                formCol:{
                    PARENTNO:'', //上级类型编码
                    PARENTNM:'',//上级类型名称
                    CODE:'', //本级类型编码
                    CNAME:'', //本级类型名称
 
                },
                addWin:false, //modal 
                loading:false,// table加载bool
                txtparam:'', // input 绑定值
                selparam:'',// select 绑定值
                oper:'like',
                tabCol:[] ,//表列格式化集合
                tabData:[] ,//表数据
                qcCol:[],
                treeObj:{},
                treeId:'0',
                page:1,
                stfgBool:true,
                // 初始化信息总条数
                dataCount:0,
                // 每页显示多少条
                pageSize:50,
                v_username:this.$cookies.get('v_telno'), //api 请求用户
                imgData:[],    
                delImg:[],
                v_corpid:this.$cookies.get('v_corpid') ,//api 请求密码
                v_url:'xuper_auth/getTableRecMany', //动态请求url接口
                addBool:false, //新增,为true时--禁止
                editBool:false, //编辑,为true时--禁止
                delBool:false, //删除 ,为true时--禁止
                cfmBool:false, //审核 ,为true时--禁止
                cancelBool:false, //作废 ,为true时--禁止 
                v_admin:this.$cookies.get('v_admin') ,//
                uploadData:{}, //上传数据 
     
                Accept: "png,jpg,jpeg,gif,pdf", //上传文件格式限制
                uploadUrl: '/xuper_oss/ftpUpload_nocheck' ,
                listurl:'',
                showViewer:false,
                v_lstseq:'',
            }
        },
        created(){
            if (this.v_username){ 
                //初始化
                this.getData(); //树形数据
                this.getTabCol(); //表列数据
     
            }else{
                let routeUrl = this.$router.resolve({
                    path: '/login',
                    query: {},
                });
                window.open(routeUrl.href, '_self');
            }
        },
        watch: {
            //对路由进行监 听，如果跳转的路由与当前的路由一样就将组件重新加载，避免路由加载后 富文本编辑框消失
            '$route' (to,from){
                this.isTinymce =false
                if(to.name==this.$route.name){
                    setTimeout(() => {
                        this.isTinymce =true
                    }, 300);
                }
            }  
        },
        mounted(){
            //操作符
            getBaseData('xuper_auth/getTableRecMany','PARENTNO','15995','','','v_sys_base','').then(res=>{
                this.operArr =res.result
            })
            //用户表单新增、编辑、审核、作废权限 :frmid:94供应商资料ID
            getBaseData(this.v_url,'userno',this.v_username,'frmidseq','104','v_sys_user_priv','').then(res=>{           
                if (this.v_admin==='N') { //表示有权限控制
                    let row =res.result[0]
                    console.log(JSON.stringify(row))
                    if (row.ISADD==='N'){ //新增
                        this.addBool=true
                    }if (row.ISUPD==='N'){ //修改
                        this.editBool=true
                    }if (row.ISDEL==='N'){ //删除
                        this.delBool=true
                    }if (row.ISCFM==='N'){ //审核
                        this.cfmBool=true
                    }if (row.ISCANCEL==='N'){ //作废
                        this.cancelBool=true
                    }
                }
            }) 
        },
        computed:{
            scrollerHeight: function() {
                return (window.innerHeight - 130) + 'px';
            },
            tabHeight(){
                return (window.innerHeight-158) + 'px'
            }  ,
            tabWidth(){
                return (window.innerWidth-160) + 'px'
            } ,
            imgHeight: function() {
                return (window.innerHeight - 140) + 'px';
            },
        },
        components: {
            tinymce,
            pubWin,
        } ,
        methods:{
            downFile(filePath){
                const arr_name=filePath.split("/")
                const file_name=arr_name[arr_name.length-1] //获取文件名
                FileSaver.saveAs(filePath,file_name) 
            },
            pdfViewer(path){
                let routeUrl = this.$router.resolve({
                    path: '/fullPreview',
                    query: {fileUrl: path},
                });
                window.open(routeUrl.href, '_blank');
            },
            btnSure(obj){
                if (this.v_key =='CHKFILENO'){
    
                    Object.assign(this.newRow,{REFIDSEQ:obj['IDSEQ'],REFLSTSEQ:obj['LSTSEQ'],CHKFILENO:obj['MFILENO'],CHKFILENM:obj['FILENM'] })     
                } 
                this.btnWin =false
            },
            inputBtn( key){   
                this.v_key =key         
                if (key=='CHKFILENO'){
                    this.v_random=Math.random()     
                    this.v_table ='V_QC_FILEDTL'
                    this.tableCol =this.qcCol
                    this.v_key2 ='ORDSTFG'
                    this.v_value2 ='Y'
                    this.btnWin =true
                }
            },
             //图片删除，操作数组
            imgDel(idseq,lstseq,path,index){
                this.$confirm('你确定要删除此附件吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.delImg.push({IDSEQ:idseq,LSTSEQ:lstseq,FILEPATH:path}) 
                    this.imgData.splice(index, 1);    
                }).catch(()=>{})
            },
            //图片预览
            imgPreview(path){
                if (path &&path.lastIndexOf('.pdf')>-1){
                    let routeUrl = this.$router.resolve({
                        path: '/fullPreview',
                        query: {fileUrl: path},
                    });
                    window.open(routeUrl.href, '_blank');
                }else{
                    this.showViewer=true
                    this.listurl=path
                }
            },
            //文件超出指定文件大小限制的钩子
            handleMaxSize (file) {
                this.promptWin =true
                this.prompt=file.name + ' 文件太大, 不能超出20M' 
            },
            //上传显示进度
            handleProgress(event,file,fileList){
                this.videoFlag = true
                this.videoUploadPercent = Math.floor(event.percent)
            },
            handleFormatError (file) {
                this.promptWin =true
                this.prompt='文件格式错误,'+file.name + ' 是不正确, 请选择图片或PDF格式'
            },
            // 文件上传成功时的钩子
            successImgFile(res,file){
                this.videoUploadPercent=0 
                this.videoFlag = false
                if (res.code=='200'){
                    this.imgData.push({FILEPATH:this.$store.state.nasUrl+res.result,FILENM:file.name,FILETY:'IMG',PATH:'/web/web_images/material/'+res.result,HASHVAL:res.hashvalue})                   
                } else{
                    this.promptWin =true
                    this.prompt =res.result
                } 
            },
            //上传文件之前的钩子 /assets/basedict/"+code+"."+v_Suffix;
            beforeImgFile (res, file) {
                this.fileName= this.v_username+getDate('year')   
                this.uploadData = {
                    code: this.fileName ,
                    p_type:'IMG',
                    p_path:'/web/web_images/material/',
                    p_user:this.v_username
                }
                let promise = new Promise(resolve => {
                this.$nextTick(function() {
                        resolve(true);
                    });
                });
                return promise;   
            },
            addInfo(){
                if (!this.treeObj['id'] ||this.treeObj['id']=='0') {
                    this.prompt='根结点下不能新增，请选择子节点'
                    this.promptWin =true
                }else{
                    this.v_lstseq=''
                    this.imgData =[]
                    window.tinymce.get('refnew').setContent('#') 
                    this.newRow={'FILETYNM':this.treeObj['label'],'DTTM':getDate(),'IDSEQ':this.treeObj['id'],CORPID:this.v_corpid,LSTSEQ:''}
                }
            },
            getRowKeys(row){
                return row.IDSEQ+'-'+row['LSTSEQ']
            },
            //节点过滤
            filterNode(value, data) {
                if (!value) return true;
                return data.label.indexOf(value) !== -1;
            },
            //节点点击
            handleNodeClick(data ){
                this.treeObj =data        
                this.treeId =data.id
                
                this.getInfoData('idseq',data.id,this.selparam,this.txtparam )
                
            },
            //保存发布信息
            saveInfo(){
                if (!this.newRow['FILETYNM']){
                    this.promptWin=true
                    this.prompt ='请选择节点'
                }else if (!this.newRow['TITLE']){
                    this.promptWin=true
                    this.prompt ='信息标题不能为空'
                }else{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/tableBodySave',
                        data: {p_json:JSON.stringify(Object.assign(this.newRow,{LSTSEQ:this.v_lstseq})), p_table:'HR_DOCITM',p_idseq:this.treeObj['id']},
                    }).then(res=>{
                        console.log(this.v_lstseq)
                        if (res.code!=='200'){
                            this.promptWin=true
                            this.prompt=res.result
                        }else{   
                            let v_lstitm =res.idseq
                            //更新大对象
                            this.$axios({
                                method: 'post',
                                url:'xuper_auth/updateRec',
                                data: {p_cond:' set note=\''+this.newHtml+'\'',p_table:'HR_DOCITM',p_key:'idseq',p_value:this.treeObj['id'],p_key2:'lstseq',p_value2: v_lstitm},
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promptWin=true
                                    this.prompt=res.result
                                }else{
                                    this.$message({ message: '已成功保存记录！', type: 'success' })
                                    this.qryTabData()
                                }
                            })
                           
                        }
                    })
                }
            },
            //确定
            saveTree(){
                var vm=this;
                //发起保存请求   
                if (this.formCol.CNAME) {
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(vm.formCol,{'CORPID':vm.v_corpid})), p_table:'hr_doc'},
                    }).then(res=>{             
                        vm.addWin =false 
                        vm.getData()                           
                    }) 
                }else{
                    this.prompt ='本级类型名称不能为空'
                    this.promptWin=true
                }
            } ,
            //新增
            addRec(){
                if (this.treeObj['id']) {
                    this.$axios({ //取到最大IDNO +1
                        method: 'post',
                        url:'xuper_auth/getMaxNum',
                        data: {p_key:'CODE',p_value:"1001" , p_table:'hr_doc'},
                    }).then(res=>{      
                        if(res.code =='200')  {  
                        // console.log(JSON.stringify(this.treeObj))
                            this.addWin =true
                            this.addFlag ='create'
                            if (this.treeObj['id']=='0'){
                                this.formCol={'PARENTNO':this.treeObj['id'],'PARENTNM':this.treeObj['icon'],'CODE':res.result,CNAME:'' }
                            }else{
                                this.formCol={'PARENTNO':this.treeObj['id'],'PARENTNM':this.treeObj['label'],'CODE':res.result,CNAME:'' }    
                            }
                        }else{
                            this.prompt=res.result
                            this.promptWin=true
                        }        
                    })
                }else{
                    this.promptWin =true
                    this.prompt ='请选择节点'
                }
            },
 
            //修改
            editRec(){
                if (this.treeObj['id']=='0'){
                    this.prompt ='根目录不能编辑'
                    this.promptWin=true
                }else{
                    this.addWin =true
                    this.addFlag ='edit'
                    this.formCol={'PARENTNO':this.treeObj['parentid'],'PARENTNM':this.treeObj['icon'],'CODE':this.treeObj['id'],CNAME:this.treeObj['label'] }
                }
            },
            delInfo(row,index){
                this.$confirm('你确定要删除此记录吗','提示',{
                    confirmButtonText: '确定',
                    cancelButtonText:'取消',
                    customClass:'messageBox',
                    showClose:false,
                    closeOnClickModal:false,
                    closeOnPressEscape:false,
                    type:'info',
                }).then(()=>{
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/delTabRec',
                        data: {p_key:'idseq',p_value:row['IDSEQ'],p_key2:'lstseq',p_value2:row['LSTSEQ'],p_table:'HR_DOCITM'},
                    }).then(res=>{ 
                        this.qryTabData()
                    })
                }).catch(()=>{})
            },
            //删除
            delRec(){
                if (this.treeObj['id']=='0'||this.treeObj['id']=='1'||this.treeObj['id']=='2'||this.treeObj['id']=='3'){
                    this.prompt ='系统目录不能删除'
                    this.promptWin =true
                }else{
                    //选判断有没子节点
                    var vm=this;
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/getBaseData',
                        data: {p_key:'parentno',p_value:this.treeObj['id'],p_key2:'corpid',p_value2:this.v_corpid,p_table:'v_hr_doc'},
                    }).then(res=>{  
                        if (res.result.length===0){
                            this.$confirm('你确定要删除此节点吗','提示',{
                                confirmButtonText: '确定',
                                cancelButtonText:'取消',
                                customClass:'messageBox',
                                showClose:false,
                                closeOnClickModal:false,
                                closeOnPressEscape:false,
                                type:'info',
                            }).then(()=>{
                                //判断有没产品引用此类型
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/getBaseData',
                                    data: {p_key:'idseq',p_value:this.treeObj['id'],p_key2:'corpid',p_value2:this.v_corpid,p_table:'v_hr_docitm'},
                                }).then(res=>{  
                                    if (res.result.length===0){
                                        //发起删除请求
                                        this.$axios({
                                            method: 'post',
                                            url:'xuper_auth/delTabRec',
                                            data: {p_key:'code',p_value:vm.treeObj['id'],p_table:'hr_doc'},
                                        }).then(res=>{            
                                            vm.getInfoData('idseq',vm.treeObj['id'],vm.selparam,vm.txtparam )
                                            vm.getData()        
                                        }) 
                                    }else{
                                        this.prompt= '该节点下已存在信息发布，不能删除'
                                        this.promptWin=true
                                    }  
                                })
                            }).catch(()=>{})
                        }else{
                            this.promptWin=true
                            this.prompt='该节点下已存在子节点，不能删除'
                        }
                    })
                }
            },
 
 
            //查询事件
            qryTabData(){
                this.getInfoData('idseq',this.treeObj['id'],this.selparam,this.txtparam );
            },
            // 获取 树形控件数据
            getData() {  
                var vm=this;
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getElTreeData',
                    data: {p_table:'V_hr_doc',p_cond:' AND corpid in (\'0\',\''+this.v_corpid+'\') order by code'}
                }).then(function(res){                  
                    vm.treeData =res.result   
                    if(res.result.length > 0 ){                  
                        vm.$nextTick().then(() =>{
                            //使用setCurrentKey方法的时候必须将其放在nextTick中,要等数据更新渲染完再调用,否则找不到对应元素
                            vm.$refs.eltree.setCurrentKey(vm.treeId)
                            if (!vm.treeObj['id']) {
                                vm.treeObj =res.result[0]
                            }
                        })
                    }               
                })                              
            },
            //获取表列头字段
            getTabCol(){
                var vm=this
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','104','lstseq','2319','','',' order by sortby,lstseq').then((res) => {                   
                    for (let k=0; k<res.result.length; k++){
                        vm.tabCol.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            edcss:res.result[k].EDCSS,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            disabled:res.result[k].DISABLED,
                            notnull:res.result[k].NOTNULL,
                        })
                    }
                })
                getTabColOrData(this.v_url,'v_sys_form_fld','idseq','104','lstseq','2320','','',' order by sortby,lstseq').then((res) => {                   
                    for (let k=0; k<res.result.length; k++){
                        vm.qcCol.push({ //向数组的开头 添加序列号
                            title: res.result[k].title,
                            key: res.result[k].key,
                            align: res.result[k].align,
                            width: res.result[k].width,
                            edcss:res.result[k].EDCSS,
                            thide:res.result[k].THIDE,
                            fhide:res.result[k].FHIDE,
                            disabled:res.result[k].DISABLED,
                            notnull:res.result[k].NOTNULL,
                            sortable:res.result[k].SORTABLE,
                        })
                    }
                })
            },
            setLobData(idseq,lstseq){
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/getClobData',
                    data: {p_key:'idseq',p_value:idseq,p_key2:'lstseq',p_value2:lstseq, p_table:'V_HR_DOCLOB' },
                }).then(res=>{ 
                    this.$nextTick(()=>{
                        window.tinymce.get('refnew').setContent(res.result[0].note)                      
                    })   
                })
            },
            rowClick(row){
                this.newRow =JSON.parse(JSON.stringify(row))
                this.v_lstseq =row['LSTSEQ']
                this.setLobData(row['IDSEQ'],row['LSTSEQ'])
                this.qryImgData(row['IDSEQ'])
            },
            qryImgData(idseq){
                this.imgData=[]
                getTabColOrData(this.v_url,'V_mat_img','idseq',idseq,'','').then((res) => {              
                    if (res){
                        this.imgData =res.result
                    }
                })
            },
            //获取表数据
            getInfoData(v_key,v_value,v_key2,v_value2 ){
                var vm=this
                getTabColOrData(this.v_url,'V_HR_DOCITM',v_key,v_value,v_key2,v_value2,'corpid',this.v_corpid,'').then((res) => {
                    //保存取到 所有数据
                    vm.tabData =res.result   
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.tabref.doLayout()                       
                    })
                    if (this.dataCount>0){
                        this.setLobData(res.result[0]['IDSEQ'],res.result[0]['LSTSEQ'])
                        this.$refs.tabref.setCurrentRow(res.result[0])
                        this.newRow =JSON.parse(JSON.stringify(res.result[0]))
            
                        this.v_lstseq =res.result[0]['LSTSEQ']
                    }else{
                        window.tinymce.get('refnew').setContent('#') 
                        this.newRow={}
                        this.v_lstseq=''
 
                    }

                })               
            }
        }
    }
</script>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-tree-node.is-current > .el-tree-node__content {
      background-color: #f3b6b6 !important;
      color:rgb(30, 44, 90);
    }
    .el-tree-node__content:hover {    
      background-color: #66b1ff87;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px !important;
            color:rgb(128,128, 128);
            font-size:12px;
        }
        td {
            padding: 5px ;
            font-size:11px;
        }   
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .el-dialog__body{
        padding: 10px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 20px; background:white;top:5px !important;}
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>
<style lang="less" scoped>
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 1px auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
    .item-width {
        width:98%;
    }
    .row-width {
        width:32%;
        height:22px;
    }
</style>

